/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Carry_SavedInputs */

const en_us2_workout_after_carry_saved = /** @type {(inputs: Workout_After_Carry_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan updated`)
};

const pt_br2_workout_after_carry_saved = /** @type {(inputs: Workout_After_Carry_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano atualizado`)
};

const es_419_workout_after_carry_saved = /** @type {(inputs: Workout_After_Carry_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan actualizado`)
};

const pt_pt2_workout_after_carry_saved = /** @type {(inputs: Workout_After_Carry_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano atualizado`)
};

const fr_fr2_workout_after_carry_saved = /** @type {(inputs: Workout_After_Carry_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme mis à jour`)
};

const de_de2_workout_after_carry_saved = /** @type {(inputs: Workout_After_Carry_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan aktualisiert`)
};

const it_it2_workout_after_carry_saved = /** @type {(inputs: Workout_After_Carry_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheda aggiornata`)
};

/**
* | output |
* | --- |
* | "Plan updated" |
*
* @param {Workout_After_Carry_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_saved = /** @type {((inputs?: Workout_After_Carry_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_saved(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_saved(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_saved(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_saved(inputs)
	return en_us2_workout_after_carry_saved(inputs)
});
export { workout_after_carry_saved as "workout-after.carry_saved" }